import React, { useMemo } from 'react';
import { Tabs, TabsProps } from 'antd';
import { CustomProduct } from '../../store/customProductSlice';
import { GeneratedContentSection } from './GeneratedContentSection';
import { ProductInputSection } from './ProductInputSection';

interface CustomProductDetailDescriptionProps {
    product: CustomProduct | null;
}

const CustomProductDetailDescription: React.FC<CustomProductDetailDescriptionProps> = ({ product }) => {
    const items = useMemo<TabsProps['items']>(() => [
        {
            key: '1',
            label: `Generated Content`,
            children: product ? (<GeneratedContentSection product={product} />) : null,
        },
        {
            key: '2',
            label: 'Product Input',
            children: product ? (<ProductInputSection product={product} />) : null,
        },
    ], [product]);

    return (
        <Tabs className="custom-product-detail-tabs" defaultActiveKey="1" items={items} />
    );
};

export default CustomProductDetailDescription;
